module.exports = __webpack_public_path__ + "img/super01.19a1e5ad.png";